import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from './../../utils/AppEventDispatcher';
import { ChangeSecurityQuestionsEventType } from './change-security-questions.event.type';
import { TweenMax, Quint, Sine } from 'gsap';
import { FormGroup } from '@angular/forms';
import { ChangeSecurityQuestions } from './model/change-security-questions';

@Component({
	selector: 'app-change-security-questions',
	templateUrl: './change-security-questions.component.html',
	styleUrls: ['./change-security-questions.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ChangeSecurityQuestionsComponent implements OnInit, OnDestroy {
	view = '[data-component="change-security-questions"]';
	public form: FormGroup;
	public submited = false;
	public activeBackButton = false;
	public showStepButtons = true;
	public subtitle = 'Se você perdeu, esqueceu ou simplesmente deseja alterar suas perguntas de segurança, é possível redefiní-las. <br/> Selecione a pergunta que deseja manter como pergunta de segurança e escreva a resposta no campo abaixo.';
	public changeQuestionsData: ChangeSecurityQuestions = new ChangeSecurityQuestions();

	constructor() { }

	ngOnInit() {
		TweenMax.delayedCall(.3, () => {
			this.show();
		});

		AppEventDispatcher.listen(ChangeSecurityQuestionsEventType.BUTTONS, data => {
			TweenMax.to('.buttons', .8, { bottom: '-100%', ease: Quint.easeOut });
			TweenMax.delayedCall(.6, () => {
				this.activeBackButton = true;

				TweenMax.delayedCall(.2, () => {
					TweenMax.to('.buttons', .8, { bottom: 0, ease: Quint.easeOut });
				});
			});

		});

	}

	show() {
		AppEventDispatcher.dispatch(ChangeSecurityQuestionsEventType.STEPS.CHANGE_SECURITY_QUESTIONS, { show: true });
		TweenMax.to('.buttons', .8, { bottom: '-100%', ease: Quint.easeOut });
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ChangeSecurityQuestionsEventType.ERROR);
		AppEventDispatcher.removeListener(ChangeSecurityQuestionsEventType.BUTTONS);
	}

	setForm(form: FormGroup) {
		this.form = form;
	}

	sendForm(event) {
		this.submited = true;

		AppEventDispatcher.dispatch(ChangeSecurityQuestionsEventType.SEND.CHANGE_SECURITY_QUESTIONS_CONFIRM_SEND, {});
	}

	public onShowStepButtons(value: boolean) {
		this.showStepButtons = value;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/change-security-questions/change-security-questions.component.ts